import _ from 'lodash'
import { useEffect, useState } from 'react'

import { IEnrollmentKlassInfo } from '@/features/curriculum/types/permission'

import { requestProgressList } from '../api'
import { IProgress } from '../types'

export const useProgressRate = (
  schoolId: string,
  courseInfo?: IEnrollmentKlassInfo | undefined,
) => {
  const [curEnrollment, setCurEnrollment] = useState<IProgress>()
  const [resourceCompletedSize, setResourceCompletedSize] = useState<number>()
  const [resourceCompletedSeconds, setResourceCompletedSeconds] = useState<number>()

  const [rate, setRate] = useState<number>(0)

  const getProgressList = async () => {
    try {
      const vodProgress = await requestProgressList(schoolId)
      setCurEnrollment(vodProgress)
      progressRate(vodProgress)
    } catch (e) {
      console.error(e)
    }
  }

  const progressRate = (progress: IProgress | null) => {
    const allResourceCompletedSize = progress
      ? _.chain(progress.chapters)
          .map(chapters => chapters.resources.filter(({ isCompleted }) => isCompleted).length)
          .sum()
          .value()
      : 0
    setResourceCompletedSize(allResourceCompletedSize)
    if (progress) {
      setRate(Math.floor((allResourceCompletedSize / progress.totalResources) * 100))
    }
  }

  useEffect(() => {
    void getProgressList()
  }, [schoolId, courseInfo])

  return {
    rate,
    resourceCompletedSize,
    resourceCompletedSeconds,
    curEnrollment: curEnrollment,
  }
}
